@if (order) {
  <ion-button
    class="calendar-button"
    fill="solid"
    size="small"
    (click)="openGoogleCalendar()"
  >
    <ion-icon slot="icon-only" name="calendar-outline"></ion-icon>
  </ion-button>
}
